import { useEffect } from 'react';

import { CURRENCY_MAP } from '@configs';
import { Currency } from '@models';
import { useProfileStore } from '@stores';

/**
 * Custom hook to initialize currency settings based on user account data
 * This hook will set the currency values in the profile store whenever
 * the user account changes or when the component mounts
 */
export const useCurrencyInitialization = () => {
  const { contextSelectedUserAccount, selectedCurrency, defaultCurrency, setSelectedCurrency, setDefaultCurrency } = useProfileStore();

  useEffect(() => {
    if (!contextSelectedUserAccount?.userId) return;

    const country = contextSelectedUserAccount?.primaryShopCountry;
    if (country && country in CURRENCY_MAP) {
      const currencyCode: Currency = CURRENCY_MAP[country];
      if (!selectedCurrency) setSelectedCurrency(currencyCode);
      if (!defaultCurrency) setDefaultCurrency(currencyCode);
    } else {
      // Default to USD if no country or country not in map
      if (!selectedCurrency) setSelectedCurrency('USD');
      if (!defaultCurrency) setDefaultCurrency('USD');
    }
  }, [contextSelectedUserAccount?.userId, selectedCurrency, defaultCurrency, setSelectedCurrency, setDefaultCurrency]);

  return null;
};

export default useCurrencyInitialization;
